// extracted by mini-css-extract-plugin
export default {"onlyDark":"ContactMe_onlyDark__bjxQy","onlyLight":"ContactMe_onlyLight__V6AG2","contact-me":"ContactMe_contact-me__JXBJB"};